export default __webpack_public_path__ + "static/ui-timesheets-dda8c6e6efa00804de21f45db8e8814e.png";